<template>
  <HeaderView />
<!--  <div class="about-us-container p-6">-->
  <div class="min-h-screen bg-gray-700">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <div class="bg-white p-6 sm:p-8 shadow-sm rounded-lg mb-12">
        <h1 class="text-3xl font-bold mb-4">About Us</h1>
        <p class="mb-4">
          Welcome to <strong>USMANHEART OÜ</strong>, a leading provider of cloud-based 3D rendering services. As a private limited company specializing in computer programming activities, we are committed to revolutionizing the way individuals and businesses experience 3D rendering.
        </p>
        <p class="mb-4">
          At USMANHEART OÜ, we understand the challenges faced by creative professionals and enthusiasts when it comes to rendering their projects efficiently and cost-effectively. That's why we have developed a state-of-the-art platform that delivers fast and affordable rendering solutions in the cloud.
        </p>
        <p class="mb-4">
          Our cutting-edge technology supports a wide range of file formats, and we offer customizable APIs and SDKs for seamless integration into your existing workflow. Whether you're a hobbyist exploring your creative passions or a professional working on complex projects, our platform is designed to meet your unique needs without compromising on quality or performance.
        </p>
        <p class="mb-4">
          With our innovative pay-per-use model, you only pay for the rendering time you actually need, eliminating the need for expensive hardware investments and saving you valuable time and resources. Our scalable infrastructure ensures that you can access our rendering services whenever you require them, giving you the flexibility to scale your projects as your business grows.
        </p>
        <p class="mb-4">
          At USMANHEART OÜ, we are driven by a passion for empowering creators with the tools they need to bring their visions to life. By leveraging the power of cloud rendering, we make 3D rendering accessible to everyone, regardless of their level of expertise or budget.
        </p>
        <p class="mb-4">
          Join us today and experience the unparalleled capabilities of cloud rendering. Connect with us to stay updated on our latest innovations, industry insights, and success stories. Together, let's unlock new dimensions of creativity and achieve breathtaking visual results.
        </p>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";

export default {
  name: 'AboutUs',
  components: {FooterView, HeaderView}
}
</script>

<!--<style scoped>-->
<!--.about-us-container {-->
<!--  max-width: 800px;-->
<!--  margin: 0 auto;-->
<!--}-->
<!--</style>-->
